<template>
  <el-select
    v-model="value"
    filterable
    remote
    :style="{width:'278px'}"
    size="mini"
    placeholder="Search & Select"
    :remote-method="handleQuery"
    :loading="loading"
  >
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>
  </el-select>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getCustomers } from '../api'

export default {
  name: 'ReportCsrDesignate',
  props: {
    rowId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      options: [],
      loading: false
    }
  },
  computed: {
    ...mapState('report', ['selectedCsrs']),
    value: {
      get () {
        return this.selectedCsrs.find(c => c.id === this.rowId).csr.name
      },
      set (val) {
        this.setCsr({ id: this.rowId, csr: val })
      }
    }
  },
  methods: {
    ...mapMutations({
      setCsr: 'report/setCsr'
    }),
    async handleQuery (name) {
      if (name !== '') {
        this.loading = true
        let data = await getCustomers({ name: name })

        this.options = data.data.map(item => ({ value: item.id, label: item.name, ...item }))
        this.loading = false
      }
    }
  }
}
</script>
